import { BaseRepository } from './BaseRepository';
import handleResponseError from './utils/handleResponseError';

export interface Prescription {
  image: string;
  success: boolean;
  errorCodes: string[];
}

export default class FileRepository extends BaseRepository<File> {
  static upload(files: Blob[]) {
    let formData = new FormData();

    files.forEach((file) => {
      formData.append(`documents[]`, file);
    });

    const requestOptions = {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: formData
    };

    return fetch(`${this.apiUrl}/document`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }: { data: { id: string; name: string }[] }) => {
        return data;
      });
  }

  static async checkPrescription(file: File): Promise<Prescription> {
    let formData = new FormData();

    formData.append(`document`, file);

    const requestOptions = {
      method: 'POST',
      headers: {
        // 'Content-Type': 'image/jpeg',
        ...this.authHeader()
      },
      body: file
    };

    try {
      const response = await fetch(
        `${this.apiUrl}/check-prescription`,
        requestOptions
      );
      const json = await response.json();

      const r = {
        image: 'data:image/jpeg;base64,' + json.image,
        success: json.success,
        errorCodes: json.errorCodes
      };

      return new Promise((resolve, reject) => {
        if (!response.ok) {
          return reject(r);
        }
        return resolve(r);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }

  static handleResponse(response: Response) {
    return response.text().then((text: string) => {
      const res = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
        }

        const error = (res && res.message) || response.statusText;
        let errorString = '';

        if (res.errors) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          for (let [key, value] of Object.entries(res.errors)) {
            errorString += `${value}<br/><br/>`;
          }
        }

        handleResponseError(response, res, errorString || error);

        return Promise.reject(error);
      }

      return res;
    });
  }
}
